<cc-date-picker
  [class.empty]="!property.value"
  [ngModel]="property._dateValue"
  (ngModelChange)="debouncedPropertyUpdated($event)"
  [name]="name"
  [container]="'body'"
>
</cc-date-picker>
